import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-upload-attachment',
  styleUrls: ['./upload-attachment.component.scss'],
  templateUrl: './upload-attachment.component.html'
})
export class UploadAttachmentComponent {
  @Input() file: any;
  @Output() fileChange: EventEmitter<any> = new EventEmitter();
  @Input() title: string | undefined;

  constructor() {
  }

  public onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file.size <= 1024 * 1024 * 20) {
      this.file = {
        file,
        file_name: file.name
      };
      this.fileChange.emit(this.file);
      event.target.value = null;
    }
  }

  public removeFile(): void {
    this.file = null;
    this.fileChange.emit(this.file);
  }

  public setInputValue(): string {
    return this.file ? this.file.file_name : '';
  }

  public showInsertButton(): boolean {
    return !(this.file instanceof Object);
  }
}
